import { FC } from 'react';
import clsx from 'clsx';
import { AlarmType, SensorFilters } from '../types/sensors';
import { ALARM_LABEL } from '../../../components/box-status-card/severity';

const ALL_TYPES: AlarmType[] = [
  'door', 'bolt', 'door_lock', 'vibration', 'energy',
  'sound', 'violation', 'request_opening_of_safe', 'maximum_time_for_open_door',
];

type Props = {
  filters: SensorFilters;
  totalsByType: Partial<Record<AlarmType, number>>;
  onChange: (next: Partial<SensorFilters>) => void;
  refreshSecondsLeft: number;
  onClearAll: () => void;
  canClearAll: boolean;
};

export const SensorsToolbar: FC<Props> = ({
  filters, totalsByType, onChange, refreshSecondsLeft, onClearAll, canClearAll,
}) => {
  const toggleType = (t: AlarmType) => {
    const cur = filters.alarm_types ?? [];
    const next = cur.includes(t) ? cur.filter((x) => x !== t) : [...cur, t];
    onChange({ alarm_types: next.length > 0 ? next : undefined, page: 1 });
  };

  const totalAll = Object.values(totalsByType).reduce<number>((a, b) => a + (b ?? 0), 0);
  const allSelected = !filters.alarm_types || filters.alarm_types.length === 0;

  return (
    <div className="card mb-3">
      <div className="card-body p-3">
        <div className="mb-3">
          <div className="text-muted fs-8 fw-bold text-uppercase mb-2">Tipos de alarme</div>
          <div className="d-flex flex-wrap" style={{ gap: 4 }}>
            <span
              role="button"
              onClick={() => onChange({ alarm_types: undefined, page: 1 })}
              className={clsx('px-3 py-1 rounded-pill', allSelected ? 'bg-primary text-white' : 'bg-light')}
              style={{ fontSize: 12, cursor: 'pointer' }}
            >
              Todos ({totalAll})
            </span>
            {ALL_TYPES.map((t) => {
              const active = filters.alarm_types?.includes(t);
              const count = totalsByType[t] ?? 0;
              return (
                <span
                  key={t}
                  role="button"
                  onClick={() => toggleType(t)}
                  className={clsx('px-3 py-1 rounded-pill', active ? 'bg-primary text-white' : 'bg-light')}
                  style={{ fontSize: 12, cursor: 'pointer' }}
                >
                  {ALARM_LABEL[t]} {count > 0 && <span className="ms-1">({count})</span>}
                </span>
              );
            })}
          </div>
        </div>
        <div className="d-flex flex-wrap align-items-center" style={{ gap: 8 }}>
          <input
            className="form-control form-control-sm"
            style={{ width: 200 }}
            placeholder="🔍 Buscar Nº CMB"
            value={filters.cmb_number ?? ''}
            onChange={(e) => onChange({ cmb_number: e.target.value || undefined, page: 1 })}
          />
          <select
            className="form-select form-select-sm"
            style={{ width: 'auto' }}
            value={filters.sort}
            onChange={(e) => onChange({ sort: e.target.value as SensorFilters['sort'] })}
          >
            <option value="gravity_desc">Ordenar: gravidade ↓</option>
            <option value="last_activity_desc">Ordenar: mais recente</option>
            <option value="oldest_first">Ordenar: mais antigo</option>
            <option value="cmb_asc">Ordenar: Nº CMB</option>
          </select>
          <div className="flex-grow-1" />
          <span className="text-muted fs-8">
            🕒 atualiza em {refreshSecondsLeft}s
          </span>
          <button
            type="button"
            className="btn btn-sm btn-light-danger"
            disabled={!canClearAll}
            onClick={onClearAll}
          >
            🧹 Limpar todos
          </button>
        </div>
      </div>
    </div>
  );
};
